var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.25,
    stroke: "#2B323B",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4697 18.6818C17.7626 18.9747 18.2374 18.9747 18.5303 18.6818C18.8232 18.3889 18.8232 17.9141 18.5303 17.6212L17.4697 18.6818ZM12.4697 13.6818L17.4697 18.6818L18.5303 17.6212L13.5303 12.6212L12.4697 13.6818Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputSearch);
export default __webpack_public_path__ + "static/media/input-search.c9120fa3b931e36f11bad20151ab9885.svg";
export { ForwardRef as ReactComponent };